import axios from "axios";
import * as employessTypes_admin from "../../types/admin/employessTypes";
import * as authTypes from "../../types/shared/authTypes";
//import moment from "moment";
import dayjs from "dayjs";

//Employee List
export const empListAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.EMPLOYEES_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/`,
      config
    );
    // console.log(data?.data?.company);
    dispatch({
      type: employessTypes_admin.EMPLOYEES_LIST_SUCCESS,
      payload: data?.data?.company,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.EMPLOYEES_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//employeeLateComingRangeReportAction
export const employeeLateComingRangeReportAction =
  (startDate, endDate) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEE_LATE_COMING_RANGE_REPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        startDate: `${dayjs(startDate).format("YYYY-MM-DD")}`,
        endDate: `${dayjs(endDate).format("YYYY-MM-DD")}`,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/report/late-report`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_LATE_COMING_RANGE_REPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data == "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_LATE_COMING_RANGE_REPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//employeeCheckinRangeReportAction
export const employeeCheckinRangeReportAction =
  (startDate, endDate, employeeId, pageNumber) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEE_CHECKIN_RANGE_REPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        startDate: `${dayjs(startDate).format("YYYY-MM-DD")}`,
        endDate: `${dayjs(endDate).format("YYYY-MM-DD")}`,
        employeeId,
        pageNumber,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/range/checkin`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_CHECKIN_RANGE_REPORT_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data == "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_CHECKIN_RANGE_REPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Employee All List
export const empAllListAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/all/data`,
      config
    );
    // console.log({ data });
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Employee User Id List
export const empIdAction = (userId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.EMPLOYEES_USER_ID_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/${userId}`,
      config
    );
    // console.log(data?.data?.company);
    dispatch({
      type: employessTypes_admin.EMPLOYEES_USER_ID_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.EMPLOYEES_USER_ID_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Employee All Screenshot
export const empAllScreenAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_SCREENSHOT_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };

    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const body = {
      date: `${dayjs(new Date()).format("YYYY-MM-DD")}`,
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/screenshot/date`,
      body,
      config
    );
    // console.log(data?.data?.company);
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_SCREENSHOT_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_SCREENSHOT_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Employee User Id List
export const empInviteEmailAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_INVITE_BY_EMAIL_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/invite/email`,
        formData,
        config
      );
      // console.log(data?.data?.company);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_INVITE_BY_EMAIL_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_INVITE_BY_EMAIL_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Employee All Activity List
export const empAllActivityAction =
  (userId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_ACTIVITY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        date: `${dayjs(date).format("YYYY-MM-DD")}`,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/${userId}/all/date/`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_ACTIVITY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_ACTIVITY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Employee All Report List
export const empAllReportAction =
  (userId, startDate, endDate) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_REPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        startDate: `${dayjs(startDate).format("YYYY-MM-DD")}`,
        endDate: `${dayjs(endDate).format("YYYY-MM-DD")}`,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/report/${userId}/range/`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_REPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_REPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Employee All Time Sheet List
export const empAllTimesheetAction =
  (userId, dates) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_TIMESHEET_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log(dates);
      const body = {
        date: `${dayjs(dates).format("YYYY-MM-DD")}`,
        today_date: `${dayjs(new Date()).format("YYYY-MM-DD")}`,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/timesheet/${userId}/date/`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_TIMESHEET_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_TIMESHEET_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//emp Single New Timesheet
export const empAllNewTimesheetAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_NEW_TIMESHEET_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log(dates);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/timesheet/get-company`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_NEW_TIMESHEET_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_NEW_TIMESHEET_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//emp Single New Timesheet
export const empAllNewTimesheetStatsAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_NEW_TIMESHEET_STATS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log(dates);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/timesheet/get-company-numbers`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_NEW_TIMESHEET_STATS_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_NEW_TIMESHEET_STATS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//emp Single New Timesheet
export const empSingleNewTimesheetAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEE_SINGLE_NEW_TIMESHEET_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log(dates);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/timesheet/get-user`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEE_SINGLE_NEW_TIMESHEET_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_SINGLE_NEW_TIMESHEET_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//emp Single New Timesheet
export const empSingleNewTimesheetStatsAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log(dates);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/timesheet/get-user-numbers`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_SINGLE_NEW_TIMESHEET_STATS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//Employee All Time Sheet List
export const empAllTimesheetForHrmAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_TIMESHEET_FOR_HRM_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/timesheet/all/data/range`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_TIMESHEET_FOR_HRM_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ALL_TIMESHEET_FOR_HRM_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Employee All Time Sheet List
export const empOvertimeAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.EMPLOYEES_OVERTIME_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/timesheet/all/data/range`,
      formData,
      config
    );
    // console.log({ data });
    dispatch({
      type: employessTypes_admin.EMPLOYEES_OVERTIME_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.EMPLOYEES_OVERTIME_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Change Employee Timesheet Status By Range
export const changeStatusTimesheetByRangeForHrmAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/timesheet/change/status/range`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_TIMESHEET_IN_RANGE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Change Many Employee Timesheet Status By Range
export const changeManyEmployeeStatusTimesheetByRangeForHrmAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/timesheet/many/change/status/range`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_MANY_EMPLOYEES_TIMESHEET_IN_RANGE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//Change Employee Timesheet Status By Range
export const changeStatusTimesheetBySingleForHrmAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/timesheet/change/status/single`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_TIMESHEET_IN_SINGLE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Employee All Time Sheet List
export const empAllTeamsAction = () => async (dispatch, getState) => {
  // Main step 1
  try {
    //step 1
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_TEAMS_REQUEST,
    });

    //step 2
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();

    //step 3
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    //step 4
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/teams/all/data/`,

      //sending header to backend to verify token
      config
    );

    //step 5
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_TEAMS_SUCCESS,
      payload: data?.data,
    });

    // Main step 2
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);

    if (!err) {
      err = "Network Error";
    }

    //  console.log(err);

    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_TEAMS_FAIL,
      payload: err,
    });

    throw Error(err);
  }
};

//Employee All Time Sheet List
export const addTimeEmpTimesheetAction =
  (formData, employeeId, projectId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ADD_TIME_IN_PROJECT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log({ formData, employeeId, projectId });
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/projecttime/${employeeId}/${projectId}/`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ADD_TIME_IN_PROJECT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_ADD_TIME_IN_PROJECT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const empAddProjectAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.ADD_ONE_EMPLOYEE_IN_PROJECT_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/addproject/create`,
      formData,
      config
    );
    // console.log({ data });
    dispatch({
      type: employessTypes_admin.ADD_ONE_EMPLOYEE_IN_PROJECT_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.ADD_ONE_EMPLOYEE_IN_PROJECT_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const empAddByProjectIdAction =
  (projectId, userId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_ONE_EMPLOYEE_IN_PROJECT_ID_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/addproject/${userId}/${projectId}`,
        {},
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.ADD_ONE_EMPLOYEE_IN_PROJECT_ID_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_ONE_EMPLOYEE_IN_PROJECT_ID_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const empEditByProjectIdAction =
  (formData, projectId, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EDIT_TIME_IN_PROJECT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(employeeId)
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/${employeeId}/edit/${projectId}`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EDIT_TIME_IN_PROJECT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EDIT_TIME_IN_PROJECT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const empTimeProDashboardDateAction =
  (token) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEE_TIMEPRO_DATE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const body = {
        date: `${dayjs(new Date()).format("YYYY-MM-DD")}`,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/dashboard/timepro/date`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEE_TIMEPRO_DATE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_TIMEPRO_DATE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const empTimeProDashboardWeekAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEE_TIMEPRO_WEEK_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let body;
      if (dayjs(new Date()).format("dddd") === "Sunday") {
        body = {
          startWeekDate: `${dayjs(new Date())
            .subtract(6, "days")
            .format("YYYY-MM-DD")}`,
          endWeekDate: `${dayjs(new Date()).format("YYYY-MM-DD")}`,
        };
      } else {
        body = {
          startWeekDate: `${dayjs(new Date()).weekday(1).format("YYYY-MM-DD")}`,
          endWeekDate: `${dayjs(new Date()).weekday(6).format("YYYY-MM-DD")}`,
        };
      }
      // body = {
      //   startWeekDate: `${moment(new Date()).weekday(1).format("YYYY-MM-DD")}`,
      //   endWeekDate: `${moment(new Date()).weekday(7).format("YYYY-MM-DD")}`,
      // };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/dashboard/timepro/week`,
        body,
        config
      );
      dispatch({
        type: employessTypes_admin.EMPLOYEE_TIMEPRO_WEEK_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_TIMEPRO_WEEK_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const empTimeProDashboardSevenAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEE_TIMEPRO_SEVEN_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const body = {
        startSevenDate: `${dayjs(new Date())
          .subtract(7, "days")
          .format("YYYY-MM-DD")}`,
        endSevenDate: `${dayjs(new Date()).format("YYYY-MM-DD")}`,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/dashboard/timepro/seven`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEE_TIMEPRO_SEVEN_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_TIMEPRO_SEVEN_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Employee All Activity List
export const empAllCheckinAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_CHECKIN_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const body = {
      date: `${dayjs(new Date()).format("YYYY-MM-DD")}`,
      // date: `${moment().subtract(1, "day").format("YYYY-MM-DD")}`,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/checkin/date/`,
      body,
      config
    );
    // console.log({ data });
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_CHECKIN_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.EMPLOYEES_ALL_CHECKIN_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const empBlockFromCompanyAction =
  (employeeId, status) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_BLOCK_FROM_COMPANY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      let formData = {
        status: status,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/blocked/${employeeId}`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_BLOCK_FROM_COMPANY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_BLOCK_FROM_COMPANY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const empDeleteFromCompanyAction =
  (employeeId, departId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_DELETE_FROM_COMPANY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/user/${employeeId}/delete/${departId}`,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_DELETE_FROM_COMPANY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_DELETE_FROM_COMPANY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const empBlockFromDepartmentAction =
  (userId, departId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_BLOCK_FROM_DEPARTMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department/remove/${departId}/${userId}`,
        {},
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_BLOCK_FROM_DEPARTMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_BLOCK_FROM_DEPARTMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const empUpdateDetailsAction =
  (employeeId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEE_DETAILS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/update/${employeeId}/detail`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEE_DETAILS_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEE_DETAILS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const deleteProjectTimeAction =
  (protimeId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.DELETE_PROJECT_TIME_OF_EMPLOYEE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      // console.log(moment(date).format("YYYY-MM-DD"));
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let body = {
        date: `${dayjs(date).format("YYYY-MM-DD")}`,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/projecttime/${protimeId}/delete`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.DELETE_PROJECT_TIME_OF_EMPLOYEE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.DELETE_PROJECT_TIME_OF_EMPLOYEE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const sendEmpResetPassEmailAction =
  (employeeId, email) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.SEND_OTP_EMAIL_BY_ADMIN_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let body = {
        email,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/resendcode/${employeeId}/`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.SEND_OTP_EMAIL_BY_ADMIN_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.SEND_OTP_EMAIL_BY_ADMIN_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const updateScreenShotAction =
  (screeshotId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_REASON_IN_EMP_SCREENSHOT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let body = {
        type: "blur",
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/screenshot/${screeshotId}/update`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.UPDATE_REASON_IN_EMP_SCREENSHOT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_REASON_IN_EMP_SCREENSHOT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const deleteScreenShotAction =
  (screeshotId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.DELETE_SCREENSHOT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let body = {
        date,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/screenshot/${screeshotId}/delete/`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.DELETE_SCREENSHOT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.DELETE_SCREENSHOT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//add user in department with project
export const addUserInDepartWithProAction =
  (employeeId, departmentName, projectId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let body = {
        departmentName: departmentName,
        projectId: projectId,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/department/${employeeId}/create/`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//add user in department with project
export const editEmpTypeAction =
  (type, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEE_TYPE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let body = {
        type,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/${employeeId}/user/type/`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEE_TYPE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEE_TYPE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//get checkIn report by range
export const getEmpCheckInByRangeAction =
  (startDate, endDate, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_CHECKIN_BY_RANGE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let body = {
        startDate,
        endDate,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/checkin/${employeeId}/range/`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_CHECKIN_BY_RANGE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_CHECKIN_BY_RANGE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//get total time payroll report by range
export const getEmpTotalTimeByRangeAction =
  (startDate, endDate, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_TOTAL_TIME_BY_RANGE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let body = {
        startDate,
        endDate,
        employeeId,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/total/time/range/`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_TOTAL_TIME_BY_RANGE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_TOTAL_TIME_BY_RANGE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Post Employee Extra Info
export const postEmpExtraInfoAction =
  (formData, employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EXTRA_INFO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/extra/info/`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EXTRA_INFO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EXTRA_INFO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Post Employee Extra Social
export const postEmpExtraSocialAction =
  (formData, employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EXTRA_SOCIAL_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/extra/social/`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EXTRA_SOCIAL_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EXTRA_SOCIAL_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Post Employee Extra Work
export const postEmpExtraWorkAction =
  (formData, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EXTRA_WORK_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/extra/work/`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EXTRA_WORK_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEES_EXTRA_WORK_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Post Employee Air Rimburst
export const postEmpAirReimburstAction =
  (formData, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_Air_REIMBURST_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/reimburst/add/`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_Air_REIMBURST_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_Air_REIMBURST_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get Employee Extra Info
export const getEmpExtraInfoAction =
  (employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.GET_EMPLOYEES_EXTRA_INFO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/extra/data/`,
        { date: `${dayjs(new Date()).format("YYYY-MM-DD")}` },
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.GET_EMPLOYEES_EXTRA_INFO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.GET_EMPLOYEES_EXTRA_INFO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Get Employee Extra Info
export const addEmpProfileImageAction =
  (employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.GET_EMPLOYEES_EXTRA_INFO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/extra/data/`,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.GET_EMPLOYEES_EXTRA_INFO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.GET_EMPLOYEES_EXTRA_INFO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//ChangedImage
export const UpdateUserProfileImageAction =
  (selectedFile, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_PROFILE_IMAGE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const employeeId = JSON.parse(localStorage.getItem("UserInfo"));

      const formData = new FormData();

      formData.append("profileImage", selectedFile);
      // console.log(formData);
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/updateimage/${employeeId}/user`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_PROFILE_IMAGE_SUCCESS,
        payload: data?.data,
      });
      // localStorage.setItem(
      //   "sharedUserInfo",
      //   JSON.stringify(data?.data, null, " ")
      // );
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_PROFILE_IMAGE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Post Employee Extra Personal Info
export const postEmpExtraPersonalAction =
  (formData, employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/profile/extra/data/`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_EXTRA_PERSONAL_INFO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Employees Asset
export const addEmpAssetAction =
  (formData, employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_ASSET_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/asset/add/`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_ASSET_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_ASSET_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Put Employees Asset
export const putEmpAssetAction =
  (formData, employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_ASSET_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/asset/update/`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_ASSET_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_ASSET_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Archived Employees Asset
export const archivedEmpAssetAction =
  (formData, employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_ARCHIVED_ASSET_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/asset/archived/`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_ARCHIVED_ASSET_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_ARCHIVED_ASSET_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's front document
export const updateEmpFrontDocAction =
  (formingData, selectedFile, selectedFile1, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_FRONT_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("frontDoc", selectedFile);
      formData.append("frontDoc", selectedFile1);
      formData.append("cnic", formingData.cnic);
      formData.append("firstName", formingData.firstName);
      formData.append("lastName", formingData.lastName);
      formData.append("mandatory", formingData.mandatory);
      formData.append("nationality", formingData.nationality);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/front/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_FRONT_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_FRONT_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's labour document
export const updateEmpLabourDocAction =
  (formingData, selectedFile, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_LABOUR_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("attachment", selectedFile);
      formData.append("labourFirstName", formingData.labourFirstName);
      formData.append("labourLastName", formingData.labourLastName);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("mandatory", formingData.mandatory);
      formData.append("docType", formingData.docType);
      formData.append("labourNo", formingData.labourNo);
      formData.append("labourIssueDate", formingData.labourIssueDate);
      formData.append("labourExpiryDate", formingData.labourExpiryDate);
      formData.append("labourDesignation", formingData.labourDesignation);
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/labour/add`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_LABOUR_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_LABOUR_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's Back document
export const updateEmpBackDocAction =
  (formingData, selectedFile1, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_BACK_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("backDoc", selectedFile1);
      formData.append("cnic", formingData.cnic);
      formData.append("firstName", formingData.firstName);
      formData.append("lastName", formingData.lastName);
      formData.append("mandatory", formingData.mandatory);
      formData.append("birthday", formingData.birthday);
      formData.append("expire", formingData.expire);
      formData.append("gender", formingData.gender);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/back/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_BACK_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_BACK_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's Back document
export const updateEmpOtherkDocAction =
  (formingData, selectedFile, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_OTHER_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("otherDoc", selectedFile);
      formData.append("description", formingData.description);
      formData.append("title", formingData.title);
      formData.append("mandatory", formingData.mandatory);
      formData.append("expire", formingData.expire);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("otherId", formingData.otherId);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/other/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_OTHER_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_OTHER_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's Passport Photo
export const updateEmpPassPortAction =
  (formingData, selectedFile, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_PASSPORT_PHOTO_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("passport", selectedFile);
      formData.append("mandatory", formingData.mandatory);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/pass/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_PASSPORT_PHOTO_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_PASSPORT_PHOTO_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's visa document
export const updateEmpVisaDocAction =
  (formingData, selectedFile, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_VISA_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("visaDoc", selectedFile);
      formData.append("nationality", formingData.nationality);
      formData.append("firstName", formingData.firstName);
      formData.append("lastName", formingData.lastName);
      formData.append("mandatory", formingData.mandatory);
      formData.append("birthday", formingData.birthday);
      formData.append("gender", formingData.gender);
      formData.append("visaExpiryDate", formingData.visaExpiryDate);
      formData.append("entryPermitNo", formingData.entryPermitNo);
      formData.append("UID", formingData.UID);
      formData.append("visaIssueDate", formingData.visaIssueDate);
      formData.append("visaPlaceOfIssue", formingData.visaPlaceOfIssue);
      formData.append("visaFileNumber", formingData.visaFileNumber);
      formData.append("visaCountry", formingData.visaCountry);
      formData.append("visaDesignation", formingData.visaDesignation);
      formData.append("visaType", formingData.visaType);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/visa/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_VISA_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_VISA_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's education document
export const updateEmpEducationDocAction =
  (formingData, selectedFile, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_EDUCATION_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("eductionDoc", selectedFile);
      formData.append("educationTitle", formingData.educationTitle);
      formData.append("educationDesc", formingData.educationDesc);
      formData.append("mandatory", formingData.mandatory);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/education/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_EDUCATION_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_EDUCATION_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's insurance document
export const updateEmpInsuranceDocAction =
  (formingData, selectedFile, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_INSURANCE_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("insuranceDoc", selectedFile);
      formData.append("insuranceTitle", formingData.insuranceTitle);
      formData.append("insuranceDesc", formingData.insuranceDesc);
      formData.append("insuranceNo", formingData.insuranceNo);
      formData.append("insuranceIssuer", formingData.insuranceIssuer);
      formData.append("insuranceType", formingData.insuranceType);
      formData.append("insuranceIssueDate", formingData.insuranceIssueDate);
      formData.append("insuranceExpiryDate", formingData.insuranceExpiryDate);
      formData.append("insuranceDesignation", formingData.insuranceDesignation);
      formData.append("mandatory", formingData.mandatory);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/insurance/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_INSURANCE_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_INSURANCE_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's Passport document
export const updateEmpPassportDocAction =
  (formingData, selectedFile1, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_PASSPORT_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("passportDoc", selectedFile1);
      formData.append("nationality", formingData.nationality);
      formData.append("firstName", formingData.firstName);
      formData.append("lastName", formingData.lastName);
      formData.append("mandatory", formingData.mandatory);
      formData.append("birthday", formingData.birthday);
      formData.append("passportNo", formingData.passportNo);
      formData.append("passportExpire", formingData.passportExpire);
      formData.append("passportIssue", formingData.passportIssue);
      formData.append("passportCountry", formingData.passportCountry);
      formData.append("passportPlaceOfIssue", formingData.passportPlaceOfIssue);
      formData.append("mainPassport", formingData.mainPassport);
      formData.append("companyPassport", formingData.companyPassport);
      formData.append("gender", formingData.gender);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/passport/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_PASSPORT_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_PASSPORT_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's Application document
export const updateEmpApplicationDocAction =
  (formingData, selectedFile1, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_APPLICATION_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("applcationDoc", selectedFile1);
      formData.append("nationality", formingData.nationality);
      formData.append("firstName", formingData.firstName);
      formData.append("lastName", formingData.lastName);
      formData.append("mandatory", formingData.mandatory);
      formData.append("birthday", formingData.birthday);
      formData.append("applicationNo", formingData.applicationNo);
      formData.append("residenceVisaExpire", formingData.residenceVisaExpire);
      formData.append("UID", formingData.UID);
      formData.append("emiratesId", formingData.emiratesId);
      formData.append("passportNo", formingData.passportNo);
      formData.append("passportExpire", formingData.passportExpire);
      formData.append("gender", formingData.gender);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/application/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_APPLICATION_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_APPLICATION_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's EmiratesId document
export const updateEmpEmiratesIdDocAction =
  (formingData, selectedFile1, selectedFile2, employeeId, companyId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_EMIRATESID_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      const formData = new FormData();
      formData.append("emiratesBackDoc", selectedFile1);
      formData.append("emiratesBackDoc", selectedFile2);
      formData.append("nationality", formingData.nationality);
      formData.append("emiratesIds", formingData.emiratesIds);
      formData.append("emiratesExpiry", formingData.emiratesExpiry);
      formData.append("emiratesIssue", formingData.emiratesIssue);
      formData.append("firstName", formingData.firstName);
      formData.append("lastName", formingData.lastName);
      formData.append("mandatory", formingData.mandatory);
      formData.append("birthday", formingData.birthday);
      formData.append("gender", formingData.gender);
      formData.append("imageUpload", formingData.imageUpload);
      formData.append("docType", formingData.docType);

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/doc/emirates/add`,
        formData,
        config
      );
      let payload = {
        payload: sharedUserInfo.payload,
        companySetting: sharedUserInfo.companySetting,
        empCompanies: sharedUserInfo.empCompanies,
        userSetting: data.data.userSetting,
      };

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(payload, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: payload,
      });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_EMIRATESID_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_EMIRATESID_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update Employee's Back document
export const archivedEmpOtherkDocAction =
  (formData, employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ARCHIVED_EMPLOYEES_OTHER_DOC_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/other/doc/archived`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.ARCHIVED_EMPLOYEES_OTHER_DOC_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.ARCHIVED_EMPLOYEES_OTHER_DOC_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Add Employees Expense
export const addEmpExpenseAction =
  (formingData, employeeId, companyId, selectedFile) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_EXPENSE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const formData = new FormData();
      formData.append("csfile", selectedFile);
      formData.append("expenseDate", formingData.expenseDate);
      formData.append("receiption", formingData.receiption);
      formData.append("expenseType", formingData.expenseType);
      formData.append("amount", formingData.amount);
      formData.append("currency", formingData.currency);
      formData.append("remark", formingData.remark);
      if (formingData?.reimburseDate) {
        formData.append("reimburseDate", formingData.reimburseDate);
      }
      if (formingData?.reimburseType) {
        formData.append("reimburseType", formingData.reimburseType);
      }
      if (formingData?.reimburseId) {
        formData.append("reimburseId", formingData.reimburseId);
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/expense/add`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_EXPENSE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_EMPLOYEES_EXPENSE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Put Employees Expense
export const putEmpExpenseAction =
  (formData, employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_EXPENSE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/expense/update`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_EXPENSE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_EXPENSE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Archived Employees Expense
export const archivedEmpExpenseAction =
  (formData, employeeId, companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/shared/type/${companyId}/${employeeId}/expense/archive`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_EMPLOYEES_ARCHIVED_EXPENSE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminOpenAnotherCompany
export const adminOpenCompanyAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_OPEN_ANOTHER_COMPANY_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let company;
      if (sharedUserInfo?.payload?.company) {
        company = sharedUserInfo?.payload?.company?._id;
      } else {
        company = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${company}/employees/owner/another`,
        { companyId },
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_OPEN_ANOTHER_COMPANY_LIST_SUCCESS,
        payload: data?.data,
      });

      localStorage.setItem(
        "sharedUserInfo",
        JSON.stringify(data?.data, null, " ")
      );
      dispatch({
        type: authTypes.SHARED_LOGIN_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_OPEN_ANOTHER_COMPANY_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminGetAllCompany
export const adminGetAllCompanyAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.ADMIN_GET_ALL_COMPANY_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/companies/get/owner/all`,
      config
    );
    // console.log(data);
    dispatch({
      type: employessTypes_admin.ADMIN_GET_ALL_COMPANY_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: employessTypes_admin.ADMIN_GET_ALL_COMPANY_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//adminOpenAnotherCompany
export const adminArchiveCompanyAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_ARCHIVE_COMPANY_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/owner/company/archive`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_ARCHIVE_COMPANY_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_ARCHIVE_COMPANY_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminAddUserImportCompany
export const adminAddUserImportCompanyAction =
  (file, invite, extension, fileName, url, publicId) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csInviteEmp", invite);
      // formdata.append("csExtension", extension);
      let formData = {
        file,
        csInviteEmp: invite,
        extension,
        fileName,
        publicId,
        url,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-employee/update-create`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_IMPORT_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminDynamicBulkImportCompany
export const adminDynamicDocumentsImportCompanyAction =
  ({ incomingData, fileName, publicId, url }) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_DYNAMIC_DOCUMENTS_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csInviteEmp", invite);
      // formdata.append("csExtension", extension);
      let formData = {
        incomingData,
        fileName,
        publicId,
        url,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-dynamic-doc/update-create`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_DYNAMIC_DOCUMENTS_IMPORT_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_DYNAMIC_DOCUMENTS_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminAddUserImportUploadCompany
export const adminAddUserImportCompanyUploadAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_IMPORT_UPLOAD_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csInviteEmp", invite);
      // formdata.append("csExtension", extension);
      let formdata = new FormData();
      formdata.append("csv", file);
      formdata.append("extension", extension);
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-employee/upload`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_IMPORT_UPLOAD_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_IMPORT_UPLOAD_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminCheckUserImportCompany
export const adminCheckUserImportCompanyAction =
  (file, csExtension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const formdata = new FormData();
      formdata.append("csfile", file);
      formdata.append("csExtension", csExtension);
      let formData = {
        file,
        csExtension,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/get/user/csv`,
        formData,
        config
      );
      // console.log(data);

      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_IMPORT_SUCCESS,
        payload: data?.data,
      });
      return data?.data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addShift
export const addShiftManagementCompanyAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/create`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADD_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addShift
export const updateSingleShiftStatusAction =
  (formData, shiftId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_STATUS_OF_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/remove/user/${shiftId}`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.UPDATE_STATUS_OF_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_STATUS_OF_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//removeShift
export const updateShiftTemplateStatusAction =
  (formData, shiftId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_TEMPLATE_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/remove/template/${shiftId}`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_TEMPLATE_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.CHANGE_STATUS_OF_TEMPLATE_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addWeekTemplateShift
export const updateWeekShiftTemplateAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_WEEK_TEMPLATE_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/template/week/`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADD_WEEK_TEMPLATE_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_WEEK_TEMPLATE_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addManyWeekShiftTemplateShift
export const addManyWeekShiftTemplateAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_MANY_EMPLOYEES_WEEK_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/many/week/add/employees`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADD_MANY_EMPLOYEES_WEEK_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_MANY_EMPLOYEES_WEEK_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//deleteManyWeekShiftTemplateShift
export const deleteManyWeekShiftTemplateAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.DELETE_MANY_EMPLOYEES_WEEK_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/many/week/unassign/employees`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.DELETE_MANY_EMPLOYEES_WEEK_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.DELETE_MANY_EMPLOYEES_WEEK_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addShift
export const updateShiftStatusAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_STATUS_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/update/many/status`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.UPDATE_STATUS_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_STATUS_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addShift
export const addBulkShiftAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.ADD_BULK_SHIFT_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    // console.log(formData);
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/many-users-shift`,
      formData,
      config
    );
    // console.log(data);
    dispatch({
      type: employessTypes_admin.ADD_BULK_SHIFT_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: employessTypes_admin.ADD_BULK_SHIFT_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//get_shift_managment
export const shiftManagementAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.GET_SHIFT_MANAGEMENT_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }

    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/get-shift`,
      config
    );
    dispatch({
      type: employessTypes_admin.GET_SHIFT_MANAGEMENT_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    dispatch({
      type: employessTypes_admin.GET_SHIFT_MANAGEMENT_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//download_shifts_action
export const downloadShiftsAction =
  (weekOrMonth, extensionName = null) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.DOWNLOAD_SHIFTS_REQUEST,
      });

      const {
        sharedLogin: { sharedUserInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const selectedDate = sessionStorage.getItem("selectedDate")
        ? dayjs(sessionStorage.getItem("selectedDate"))
        : dayjs();

      let startDate;
      if (weekOrMonth === "week") {
        startDate = selectedDate
          .clone()
          .startOf("isoWeek")
          .format("YYYY-MM-DD");
      } else if (weekOrMonth === "month") {
        startDate = selectedDate.clone().startOf("month").format("YYYY-MM-DD");
      }
      const formData = { startDate, weekOrMonth, extensionName };

      let apiEndpoint;
      if (extensionName) {
        formData.extensionName = extensionName;
        apiEndpoint = `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/reports-download/shiftdownload`;
      } else {
        apiEndpoint = `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/download/shifts/pdf`;
      }
      const { data } = await axios.post(apiEndpoint, formData, config);
      dispatch({
        type: employessTypes_admin.DOWNLOAD_SHIFTS_SUCCESS,
        payload: data,
      });
      return data;
    } catch (error) {
      let errorMessage = "Network Error";
      if (error.response && error.response.data) {
        errorMessage =
          error.response.data.message ||
          error.response.data.error ||
          "Unknown error";
      }
      dispatch({
        type: employessTypes_admin.DOWNLOAD_SHIFTS_FAIL,
        payload: errorMessage,
      });
      throw new Error(errorMessage);
    }
  };

//get-emp-filter
export const getEmpFilterAction =
  (userIds, statusArr, shiftArr) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.GET_EMP_FILTER_REQUEST,
      });

      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const selectedDate = sessionStorage.getItem("selectedDate")
        ? dayjs(sessionStorage.getItem("selectedDate"))
        : dayjs();
      const filterType = localStorage.getItem("filterType") || "week";
      let startDate, endDate;

      if (filterType === "week") {
        startDate = selectedDate
          .clone()
          .startOf("isoWeek")
          .format("YYYY/MM/DD");
        endDate = selectedDate.clone().endOf("isoWeek").format("YYYY/MM/DD");
      } else if (filterType === "month") {
        startDate = selectedDate.clone().startOf("month").format("YYYY/MM/DD");
        endDate = selectedDate.clone().endOf("month").format("YYYY/MM/DD");
      } else if (filterType === "day") {
        startDate = selectedDate.clone().startOf("day").format("YYYY/MM/DD");
        endDate = selectedDate.clone().endOf("day").format("YYYY/MM/DD");
      }

      // Log to verify dates are correct
      //console.log("getEmpFilterAction - startDate:", startDate);
      //console.log("getEmpFilterAction - endDate:", endDate);

      const formData = {
        userIds,
        shiftArr,
        statusArr,
        startDate,
        endDate,
      };
      //console.log("formdata", formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/get/shifts/paginated`,
        formData,
        config
      );

      dispatch({
        type: employessTypes_admin.GET_EMP_FILTER_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let errorMessage = "Network Error";
      if (error.response && error.response.data) {
        errorMessage =
          error.response.data.message ||
          error.response.data.error ||
          "Unknown error";
      }

      dispatch({
        type: employessTypes_admin.GET_EMP_FILTER_FAIL,
        payload: errorMessage,
      });

      throw new Error(errorMessage);
    }
  };

//getShift
export const getShiftManagementCompanyAction =
  (
    body = {
      startTime: sessionStorage.getItem("selectedDate")
        ? sessionStorage.getItem("selectedDate")
        : new Date(),
    }
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.GET_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      body.endTime = body.startTime;
      // console.log(formData);

      const formdata = {
        startTime: dayjs(body?.startTime)
          .subtract(1, "month")
          .startOf("month")
          .toDate(),
        endTime: dayjs(body?.startTime).add(1, "month").endOf("month").toDate(),
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/get-all`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.GET_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.GET_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addUserIdShift
export const addUserIdInShiftManagementCompanyAction =
  (userId, shiftId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_USER_ID_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/add/${userId}/${shiftId}`,
        {},
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADD_USER_ID_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_USER_ID_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addManyUserIdShift
export const addManyUserIdInShiftManageCompanyAction =
  (formData, shiftId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_MANY_USER_ID_IN_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/added/many/${shiftId}`,
        formData,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADD_MANY_USER_ID_IN_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_MANY_USER_ID_IN_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//getWorkBreak
export const getWorkBreakCompanyAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.GET_WORK_BREAK_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    // console.log(formData);
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/break`,
      config
    );
    // console.log(data);
    dispatch({
      type: employessTypes_admin.GET_WORK_BREAK_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    // //  console.log(err);
    dispatch({
      type: employessTypes_admin.GET_WORK_BREAK_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//addWorkBreak
export const addWorkBreakCompanyAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_WORK_BREAK_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/create/break`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.ADD_WORK_BREAK_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_WORK_BREAK_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addUserInWorkBreak
export const addUserInWorkBreakAction =
  (formData, workId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_USER_IN_WORK_BREAK_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/add/work/many/${workId}`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.ADD_USER_IN_WORK_BREAK_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_USER_IN_WORK_BREAK_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//removeUserInWorkBreak
export const removeUserInWorkBreakAction =
  (formData, workId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.REMOVE_USER_IN_WORK_BREAK_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/remove/work/many/${workId}`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.REMOVE_USER_IN_WORK_BREAK_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.REMOVE_USER_IN_WORK_BREAK_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//removeUserInWorkBreak
export const removeUserInShiftAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_MANY_USER_ID_IN_SHIFT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/shift/remove/many/`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.ADD_MANY_USER_ID_IN_SHIFT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_MANY_USER_ID_IN_SHIFT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminAddUserInDpartmentImportCompany
export const adminAddUserInDepartImportCompanyAction =
  (file, invite, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_DEPARTMENT_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csInviteEmp", invite);
      // formdata.append("csExtension", extension);
      let formdata = {
        file,
        csInviteEmp: invite,
        csExtension: extension,
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/add/depart/csv`,
        formdata,
        config
      );

      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_DEPARTMENT_IMPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_DEPARTMENT_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminCheckUserInDepartImportCompany
export const adminCheckUserInDepartImportCompanyAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_DEPARTMENT_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };

      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      let formdata = {
        file,
        csExtension: extension,
      };
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/get/depart/user/csv`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_DEPARTMENT_IMPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_DEPARTMENT_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminAddUserLeavDaysImportCompany
export const adminAddUserLeaveDaysImportCompanyAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_LEAVEDAYS_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      let formdata = {
        file,
        csExtension: extension,
      };
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/add/leavedays/csv`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_LEAVEDAYS_IMPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_LEAVEDAYS_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminCheckUserLeavDaysImportCompany
export const adminCheckUserLeaveDaysImportCompanyAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      let formdata = {
        file,
        csExtension: extension,
      };
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/get/leavedays/user/csv`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_LEAVEDAYS_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminAddUserLeavesImportCompany
export const adminAddUserLeavesImportCompanyAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_LEAVES_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      let formdata = {
        file,
        csExtension: extension,
      };
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/add/leave/csv`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_LEAVES_IMPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_LEAVES_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminCheckUserLeavesImportCompany
export const adminCheckUserLeavesImportCompanyAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_LEAVES_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      let formdata = {
        file,
        csExtension: extension,
      };
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/get/leave/user/csv`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_LEAVES_IMPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_LEAVES_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminAddUserCheck-in-outImportCompany
export const adminAddUserCheckInOutImportCompanyAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_CHECKINOUT_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      let formdata = {
        file,
        csExtension: extension,
      };
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/add/check/csv`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_CHECKINOUT_IMPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_ADD_USER_CHECKINOUT_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminUpdateBulkCompanyAction
export const adminUpdateBulkCompanyAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_UPDATE_BULK_EMPLOYEE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      let formdata = {
        file,
        csExtension: extension,
      };
      // console.log(formData);
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/update/csv`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_UPDATE_BULK_EMPLOYEE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_UPDATE_BULK_EMPLOYEE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//adminCheckUserCheck-in-outImportCompany
export const adminCheckUserCheckInOutImportCompanyAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_CHECKINOUT_IMPORT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // const formdata = new FormData();
      // formdata.append("csfile", file);
      // formdata.append("csExtension", extension);
      let formdata = {
        file,
        csExtension: extension,
      };
      // console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/get/check/user/csv`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_CHECKINOUT_IMPORT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADMIN_CHECK_USER_CHECKINOUT_IMPORT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//addUserCheckinTimeSheet
export const addUserCheckinTimeSheetAction =
  (formdata, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_USER_CHECKIN_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/add/${employeeId}/checkin`,
        formdata,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.ADD_USER_CHECKIN_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_USER_CHECKIN_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//deleteUserCheckinTimeSheet
export const deleteUserCheckinTimeSheetAction =
  (id, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.DELETE_USER_CHECKIN_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/${id}/${employeeId}/checkin`,
        config
      );
      // console.log(data);
      dispatch({
        type: employessTypes_admin.DELETE_USER_CHECKIN_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      // //  console.log(err);
      dispatch({
        type: employessTypes_admin.DELETE_USER_CHECKIN_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const getHrmCheckInAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.GET_SEVEN_DAYS_USER_CHECKIN_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let body = {
      startDate: `${dayjs(new Date())
        .subtract(7, "days")
        .format("YYYY-MM-DD")}`,
      endDate: `${dayjs(new Date()).format("YYYY-MM-DD")}`,
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/productivity/checkin`,
      body,
      config
    );
    // console.log({ data });
    dispatch({
      type: employessTypes_admin.GET_SEVEN_DAYS_USER_CHECKIN_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.GET_SEVEN_DAYS_USER_CHECKIN_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const getAllDocsAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.GET_ALL_USER_DOCS_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/all/docs`,
      {},
      config
    );
    // console.log({ data });
    dispatch({
      type: employessTypes_admin.GET_ALL_USER_DOCS_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.GET_ALL_USER_DOCS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const uploadSalaryCSVAction = (file) => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.EMPLOYEE_SALARY_CSV_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    let formdata = {
      file,
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/salary/csv`,
      formdata,
      config
    );
    // console.log({ data });
    dispatch({
      type: employessTypes_admin.EMPLOYEE_SALARY_CSV_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.EMPLOYEE_SALARY_CSV_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

export const editEmployeeAction =
  (formData, employeeId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EDIT_EMPLOYEE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(employeeId)
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/${employeeId}/new-update`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EDIT_EMPLOYEE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EDIT_EMPLOYEE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const addNewEmployeeAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.ADD_NEW_EMPLOYEE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/create/user`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.ADD_NEW_EMPLOYEE_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.ADD_NEW_EMPLOYEE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update user document
export const updateUserDocumentAction =
  (formData, id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_USER_DOCUMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dynamic-user-doc/${id}/update`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.UPDATE_USER_DOCUMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_USER_DOCUMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Update change user document
export const updateChangeUserDocumentAction =
  (formData, id) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPDATE_CHANGE_USER_DOCUMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dynamic-user-doc/${id}/update-expired`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.UPDATE_CHANGE_USER_DOCUMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPDATE_CHANGE_USER_DOCUMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//create user document
export const createUserDocumentAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.CREATE_USER_DOCUMENT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dynamic-user-doc/create`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.CREATE_USER_DOCUMENT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.CREATE_USER_DOCUMENT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//uploadUserDocumentFile
export const uploadUserDocumentFileAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.UPLOAD_USER_DOCUMENT_FILE_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dynamic-user-doc/create`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.UPLOAD_USER_DOCUMENT_FILE_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.UPLOAD_USER_DOCUMENT_FILE_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//getAllUserDynamicDocs
export const getAllUserDynamicDocumentsAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.GET_ALL_USER_DYNAMIC_DOCUMENTS_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dynamic-user-doc/get-all`,
        config
      );
      dispatch({
        type: employessTypes_admin.GET_ALL_USER_DYNAMIC_DOCUMENTS_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.GET_ALL_USER_DYNAMIC_DOCUMENTS_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//getDepartmentHierarchy
export const getDepartmentHierarchyAction =
  () => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.GET_DEPARTMENT_HIERARCHY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/hierarchy/get-by-dept`,
        config
      );
      dispatch({
        type: employessTypes_admin.GET_DEPARTMENT_HIERARCHY_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.GET_DEPARTMENT_HIERARCHY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
//getCompanyHierarchy
export const getCompanyHierarchyAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.GET_COMPANY_HIERARCHY_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    let sharedUser = "";
    if (sharedUserInfo?.payload?.token) {
      sharedUser = sharedUserInfo?.payload?.token;
    } else {
      sharedUser = sharedUserInfo?.payload?.token;
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUser}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }

    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/hierarchy/get`,
      config
    );
    dispatch({
      type: employessTypes_admin.GET_COMPANY_HIERARCHY_SUCCESS,
      payload: data?.data,
    });

    return data;
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: employessTypes_admin.GET_COMPANY_HIERARCHY_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//changeCompanyHierarchy
export const changeCompanyHierarchyAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.CHANGE_COMPANY_HIERARCHY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      let sharedUser = "";
      if (sharedUserInfo?.payload?.token) {
        sharedUser = sharedUserInfo?.payload?.token;
      } else {
        sharedUser = sharedUserInfo?.payload?.token;
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUser}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/hierarchy/update-user`,
        formData,
        config
      );
      dispatch({
        type: employessTypes_admin.CHANGE_COMPANY_HIERARCHY_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.CHANGE_COMPANY_HIERARCHY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const employeeLeaveAddStepperAction =
  (employeeId, formData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: employessTypes_admin.EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      // console.log(employeeId)
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/company/leave/${employeeId}/detail`,
        formData,
        config
      );
      // console.log({ data });
      dispatch({
        type: employessTypes_admin.EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: employessTypes_admin.EMPLOYEE_ADD_STEPPER_LEAVE_REQUEST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//GET_LEAVE_BY_USER
export const getLeaveByUserAction = (userId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: employessTypes_admin.GET_LEAVE_BY_USER_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    let sharedUser = "";
    if (sharedUserInfo?.payload?.token) {
      sharedUser = sharedUserInfo?.payload?.token;
    } else {
      sharedUser = sharedUserInfo?.payload?.token;
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUser}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/employees/all-leave-type/${userId}`,
      config
    );

    dispatch({
      type: employessTypes_admin.GET_LEAVE_BY_USER_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);

    if (!err) {
      err = "Error occurred while getting leaves";
    }

    dispatch({
      type: employessTypes_admin.GET_LEAVE_BY_USER_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
